/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(1);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// spinnerLocation will store a reference to our spinner's GIF file
	var spinnerLocation = void 0;
	var xhrResponseCache = {};
	
	var isWidgetViewer = /\?widgets=[\w-]+@\d+\.\d+\.\d+&loaderVersion=\d+\.\d+\.\d+(?:&host)?/.test(window.location.href);
	
	function getCacheKey(widgetName, widgetVersion) {
	  return widgetName + '-' + widgetVersion;
	}
	
	/**
	  * Create script element and append it to the head
	  *
	  * @param {object<Element>} _script Script element
	  * @param {object} options Function options
	  * @returns {object<Element>} Script element
	  */
	function createScript(_script) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var script = document.createElement('script');
	
	  var skipBabelPolyFill = options.skipBabelPolyFill;
	
	  // Copy the following properties
	
	  var props = ['async', 'charset', 'crossorigin', 'integrity', 'language', 'nonce', 'onload', 'referrerpolicy', 'src', 'type'];
	
	  props.forEach(function (prop) {
	    var propVal = _script.getAttribute(prop);
	    if (prop === 'src') {
	      if (propVal) {
	        // skip babel-polyfill loading when specified in config
	        if (skipBabelPolyFill && script.src.indexOf("babel-polyfill.js") !== -1) return;
	
	        script[prop] = propVal + '?_=' + Date.now();
	        return;
	      } else {
	        script.innerHTML = _script.innerHTML.replace('.config({', '.config({urlArgs: "_=" + Date.now(),');
	      }
	    }
	
	    if (!propVal) return;
	
	    script[prop] = propVal;
	  });
	
	  // Append the script to the head
	  document.getElementsByTagName('head')[0].appendChild(script);
	
	  return script;
	}
	
	/**
	  * IE11 and older script loader
	  *
	  * @param {object<Array>} scripts Collection of script elements
	  * @param {object} options Function options
	  */
	function IELegacyScriptLoader(scripts, options) {
	  if (!Array.isArray(scripts)) return;
	  if (scripts.length === 0) return;
	  var jscripts = [].slice.call(scripts || []);
	  var s = jscripts.pop();
	  s = createScript(s, options);
	
	  // Ignore async modules it is up to the developers to properly handle it
	  if (s.onload) return IELegacyScriptLoader(jscripts, options);
	
	  s.onload = function () {
	    IELegacyScriptLoader(jscripts, options);
	  };
	}
	
	/** 
	 * To get Widget Loader Spinnner path.
	 * @returns {string} Widget Loader spinner path. 
	 */
	function getWidgetLoaderSpinnerPath() {
	  var scripts = [].slice.call(document.getElementsByTagName('script') || []);
	  var widgetLoaderIndexRegex = '(http|https)://(.)*/spa/widgets/loader/([0-9]+).([0-9]+).([0-9]+)/index.js';
	  var widgetLoaderScripts = scripts.reverse().filter(function (script) {
	    return script.src && script.src.match(widgetLoaderIndexRegex);
	  });
	
	  if (widgetLoaderScripts && widgetLoaderScripts.length) {
	    var currentScriptPath = widgetLoaderScripts[0].src.split('/');
	    currentScriptPath[currentScriptPath.length - 1] = 'loading.gif';
	    return currentScriptPath.join('/');
	  } else {
	    console.error('Widget loader script does not exist');
	    return false;
	  }
	}
	
	/** 
	 * To get cached widget response.
	 * @param {string} name Widget name. 
	 * @param {string} version Widget version.
	 * @returns {string} Cached Widget response. 
	 */
	function getCachedWidget(name, version) {
	  var cacheKey = getCacheKey(name, version);
	  return xhrResponseCache[cacheKey];
	}
	
	/** 
	 * To remove widget response from cache.
	 * @param {string} name Widget name. 
	 * @param {string} version Widget version.
	 * @returns {boolean} True/False for deletion of an object from cache. 
	 */
	function cleanCachedWidget(name, version) {
	  var cacheKey = getCacheKey(name, version);
	  return delete xhrResponseCache[cacheKey];
	}
	
	/**
	 * @method getDispatcherElement
	 * @description checks to see if DispatcherElement exists and creates it if necessary
	 * @returns Node
	 */
	function getDispatcherElement() {
	  /**
	   * @const dispatcherDataAttribute
	   * @description data attribute that our DispatcherElement will have
	   */
	  var dispatcherDataAttribute = 'sparta-event-dispatcher';
	
	  /**
	   * @const dispatcherElementSelector
	   * @description selector that will be used to determine if our DispatcherElement already exists
	   */
	  var dispatcherElementSelector = '[data-' + dispatcherDataAttribute + ']';
	
	  /**
	   * @const element
	   * @description selected DispatcherElement from document
	   */
	  var element = document.querySelector(dispatcherElementSelector);
	
	  // if DispatcherElement does not yet exist
	  if (!element) {
	    /**
	     * @const generatedElement
	     * @description created element to become our DispatcherElement
	     */
	    var generatedElement = document.createElement('div');
	
	    // set our DispatcherElement data attribute
	    generatedElement.setAttribute('data-' + dispatcherDataAttribute, true);
	    spinnerLocation = getWidgetLoaderSpinnerPath();
	
	    return generatedElement;
	  }
	
	  // return selected DispatcherElement element
	  return element;
	}
	
	var EVENTS = {
	  ERROR_LOADING_WIDGET: "errorLoadingWidget",
	  REFRESH_WIDGET: "refreshWidget"
	
	  /**
	   * @class WidgetLoader
	   * @description class for our WidgetLoader that will initialize widgets and facilitate communication between widget and page
	   */
	};
	var WidgetLoaderClass = function () {
	  /**
	   * @method constructor
	   * @description initializes a new instance of WidgetLoader and makes sure our DispatcherElement exists
	   */
	  function WidgetLoaderClass() {
	    _classCallCheck(this, WidgetLoaderClass);
	
	    this.dispatcherElement = getDispatcherElement();
	  }
	
	  /**
	   * @method pub
	   * @description creates and dispatches a native CustomEvent on our DispatcherElement
	   * @param {String} eventName the event name to dispatch
	   * @param {*} [detail={}] the event data to attach to the event.detail parameter
	   */
	
	
	  _createClass(WidgetLoaderClass, [{
	    key: 'pub',
	    value: function pub(eventName) {
	      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      /**
	       * @const evt
	       * @description native CustomEvent to dispatch
	       */
	      var evt = new CustomEvent(eventName, { detail: detail });
	
	      // dispatch our CustomEvent from our DispatcherElement
	      this.dispatcherElement.dispatchEvent(evt);
	    }
	
	    /**
	     * @method sub
	     * @description attaches an event listener to our DispatcherElement
	     * @param {String} eventName the event name to listen for
	     * @param {Function} callback the event handler to fire
	     */
	
	  }, {
	    key: 'sub',
	    value: function sub(eventName, callback) {
	      // add event listener to DispatcherElement
	      this.dispatcherElement.addEventListener(eventName, callback);
	    }
	
	    /**
	     * @method unsub
	     * @description allows subscriber to unsubscribe from event
	     * @param {String} eventName the event name to listen for
	     * @param {Function} callback the event handler to fire
	     */
	
	  }, {
	    key: 'unsub',
	    value: function unsub(eventName, callback) {
	      this.dispatcherElement.removeEventListener(eventName, callback);
	    }
	
	    /**
	     * @method once
	     * @description allows subscriber to listen to one instance of event and then unsub
	     * @param {String} eventName the event name to listen for
	     * @param {Function} callback the event handler to fire
	     */
	
	  }, {
	    key: 'once',
	    value: function once(eventName, callback) {
	      var _this = this;
	
	      var fn = function fn(e) {
	        _this.dispatcherElement.removeEventListener(eventName, fn);
	
	        callback(e);
	      };
	
	      this.dispatcherElement.addEventListener(eventName, fn);
	    }
	
	    /**
	     * @method canRefreshWidget
	     * @description To determine if we can refresh Widgets.
	     * @param {string} widgetName Widget name.
	     * @param {string} widgetVersion Widget version.
	     * @param {boolean} enableWidgetRefresh Optional Flag to enable/disable widget refresh. Default value is true.
	     * @returns {boolean} Return true if we can refresh widgets.
	     */
	
	  }, {
	    key: 'canRefreshWidget',
	    value: function canRefreshWidget(widgetName, widgetVersion, enableWidgetRefresh) {
	      // refresh widget if it exists, otherwise load it
	      var widgets = [].slice.call(document.querySelectorAll('[data-sparta-container="' + widgetName + '"][data-version="' + widgetVersion + '"]') || []);
	
	      return enableWidgetRefresh && widgets.length > 0;
	    }
	
	    /**
	     * @method load
	     * @description loads a widget into the specified container
	     * @param {Object} Config object, must contain keys 'name, version, container, path', optional spinner Boolean value
	     */
	
	  }, {
	    key: 'load',
	    value: function load(_ref) {
	      var name = _ref.name,
	          version = _ref.version,
	          container = _ref.container,
	          path = _ref.path,
	          spinner = _ref.spinner,
	          _ref$options = _ref.options,
	          options = _ref$options === undefined ? {} : _ref$options,
	          _ref$language = _ref.language,
	          language = _ref$language === undefined ? 'en' : _ref$language,
	          _ref$enableWidgetRefr = _ref.enableWidgetRefresh,
	          enableWidgetRefresh = _ref$enableWidgetRefr === undefined ? true : _ref$enableWidgetRefr,
	          _ref$enableWidgetCach = _ref.enableWidgetCache,
	          enableWidgetCache = _ref$enableWidgetCach === undefined ? false : _ref$enableWidgetCach;
	
	      // remove cache if enableWidgetCache is false.
	      if (!enableWidgetCache) {
	        cleanCachedWidget(name, version);
	      }
	
	      if (!name || !version || !container) {
	        console.error('invalid config object passed to widget loader');
	        return false;
	      }
	
	      var containersById = [];
	      var containerNodes = [];
	
	      // check if loading widget in multiple places
	      if (Object.prototype.toString.call(container) === "[object Array]") {
	        window.sparta.widgetLoader[name] = _defineProperty({}, version, {});
	        containersById = container;
	      } else {
	        containersById.push(container);
	      }
	
	      // loop over the containers, check if they exist and load as appropriate
	      containersById.forEach(function (currentContainer) {
	        // window.sparta.widgetLoader[name][version][currentContainer] = {loaded:false};
	
	        // get Node for widget container
	        var dest = document.getElementById(currentContainer);
	
	        // if widget container does not exist
	        if (!dest) {
	          console.error('widget container destination does not exist');
	          return false;
	        }
	
	        containerNodes.push(dest);
	      });
	
	      if (this.canRefreshWidget(name, version, enableWidgetRefresh)) {
	        this.pub(EVENTS.REFRESH_WIDGET, { name: name, version: version, container: containerNodes });
	      } else {
	        if (!getCachedWidget(name, version)) {
	          this.generateStyleSheet(containerNodes, spinner);
	        }
	        this.widgetXHR(containerNodes, path, name, version, options, language);
	      }
	    }
	
	    /**
	     * @method generatedStyleSheet
	     * @description add stylesheet for loading states so we don't need another HTTP request
	     * @param {Array} containers array of widget container Nodes
	     * @param {Boolean} [spinner=true] should we use default spinner
	     */
	
	  }, {
	    key: 'generateStyleSheet',
	    value: function generateStyleSheet(containers) {
	      var spinner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      containers.forEach(function (dest) {
	        // generate stylesheet for loading
	        var style = document.createElement('style');
	
	        var styles = '\n        #' + dest.id + ' > [data-sparta-container].sparta-widget-loading,\n        #' + dest.id + ' > [data-sparta-container].sparta-widget-loading > .sparta-widget {\n          visibility: hidden;\n          height: 100%;\n          width: 100%;\n        }\n      ';
	
	        // if we are supposed to show our spinner, add a style to the widget container
	        if (spinner) {
	          styles += '\n          #' + dest.id + '.sparta-widget-loading {\n            height: 100%;\n            background-image: url(\'' + spinnerLocation + '\');\n            background-repeat: no-repeat;\n            background-position: center center;\n          }\n        ';
	        }
	
	        // add stylesheet to page
	        style.type = 'text/css';
	        style.id = dest.id + '-sparta-widget-style-sheet';
	
	        if (style.stylesSheet) {
	          style.styleSheet.cssText = styles;
	        } else {
	          style.appendChild(document.createTextNode(styles));
	        }
	
	        document.head.appendChild(style);
	
	        dest.classList.add('sparta-widget-loading');
	      });
	    }
	
	    /**
	     * @method widgetXHR
	     * @description loads widget via AJAX request
	     * @param {Array} containers array of widget container Nodes
	     * @param {String} path where to load the widget from
	     * @param {String} name the name of the widget
	     * @param {String} version the version number of the widget to load
	     * @param {String} language the language to attempt to load (en default)
	     */
	
	  }, {
	    key: 'widgetXHR',
	    value: function widgetXHR(containers, path, name, version, options, language) {
	      function xhrFunc(responseText, wasCached) {
	        containers.forEach(function (currentContainer) {
	          currentContainer.innerHTML = responseText;
	        });
	
	        // grab the last item and load the JS into that
	        var dest = containers[containers.length - 1];
	        dest.style.height = 'auto';
	        dest.style.backgroundImage = '';
	
	        // get all script tags so we can make the scripts load
	        var myScripts = [].slice.call(dest.querySelectorAll('script') || []);
	
	        var removeScriptsFromDom = function removeScriptsFromDom(scripts) {
	          return scripts.forEach(function (script) {
	            return script.parentNode.removeChild(script);
	          });
	        };
	        dest.querySelector("[data-sparta-widget]").setAttribute("data-sparta-options", JSON.stringify(options));
	
	        if (wasCached) {
	          //Since Scripts are added to <head> during first run, we need not to keep it during reload.
	
	          var initArray = [];
	          var moduleArray = [].slice.call(dest.querySelectorAll('[data-component="module"]') || []);
	          moduleArray.forEach(function (element) {
	            if (element.dataset.module.indexOf('module') !== -1) {
	              var dataset = element.dataset;
	              initArray.push(window.sparta.require[name][version].require('modules/' + dataset.moduleRef + '/' + dataset.version + '/js/' + dataset.module));
	            }
	          });
	
	          var bootstrap = window.sparta.require[name][version].require('global/sparta-bootstrap-utility');
	          var widget = window.sparta.require[name][version].require('modules/' + name + '/' + version + '/js/' + name);
	          initArray.push(widget);
	          bootstrap.default.init(initArray, { name: name, version: version });
	        } else {
	          // iterate through scripts
	          if (window.navigator.userAgent.match(/(MSIE|Trident)/)) {
	            IELegacyScriptLoader(myScripts.reverse(), options);
	          } else {
	            myScripts.forEach(createScript);
	          }
	          // Remove all scripts from Widget DOM Container
	          removeScriptsFromDom(myScripts);
	        }
	      }
	
	      var xhrResponseFromCache = getCachedWidget(name, version);
	
	      if (xhrResponseFromCache) {
	        xhrFunc(xhrResponseFromCache, true);
	        return;
	      }
	
	      var xhrReq = new XMLHttpRequest();
	      if (!isWidgetViewer) xhrReq.withCredentials = true;
	
	      var LANG_PATH = !language || language.toLowerCase() === "en" ? "" : language.toLowerCase() + '/';
	      var WIDGET_PATH = path + '/spa/widgets/' + name + '/' + version + '/' + LANG_PATH + 'index.html?_=' + Date.now();
	      var self = this;
	
	      // execute AJAX request
	      xhrReq.open('GET', WIDGET_PATH);
	
	      xhrReq.onreadystatechange = function () {
	        var _this2 = this;
	
	        if (this.readyState === 4) {
	          if (this.status !== 200) {
	            console.error('unable to load widget:', WIDGET_PATH, this.status);
	
	            containers.forEach(function (dest) {
	              dest.innerHTML = 'unable to load widget';
	              self.pub(EVENTS.ERROR_LOADING_WIDGET, { widget: { name: name, version: version, path: path, container: dest }, xhrReq: _this2 });
	            });
	          } else {
	            var cacheKey = getCacheKey(name, version);
	            xhrResponseCache[cacheKey] = this.responseText;
	            xhrFunc(this.responseText, false);
	          }
	        }
	      };
	
	      xhrReq.send();
	    }
	  }]);
	
	  return WidgetLoaderClass;
	}();
	
	if (!(window.sparta && window.sparta.widgetLoader)) {
	  var widgetLoader = new WidgetLoaderClass();
	
	  window.sparta = window.sparta || {};
	
	  window.sparta.widgetLoader = widgetLoader;
	
	  document.dispatchEvent(new CustomEvent('spartaLoaderLoaded'));
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// Polyfill for creating CustomEvents on IE9/10/11
	
	// code pulled from:
	// https://github.com/d4tocchini/customevent-polyfill
	// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
	
	try {
	    var ce = new window.CustomEvent('test');
	    ce.preventDefault();
	    if (ce.defaultPrevented !== true) {
	        // IE has problems with .preventDefault() on custom events
	        // http://stackoverflow.com/questions/23349191
	        throw new Error('Could not prevent default');
	    }
	} catch(e) {
	  var CustomEvent = function(event, params) {
	    var evt, origPrevent;
	    params = params || {
	      bubbles: false,
	      cancelable: false,
	      detail: undefined
	    };
	
	    evt = document.createEvent("CustomEvent");
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    origPrevent = evt.preventDefault;
	    evt.preventDefault = function () {
	      origPrevent.call(this);
	      try {
	        Object.defineProperty(this, 'defaultPrevented', {
	          get: function () {
	            return true;
	          }
	        });
	      } catch(e) {
	        this.defaultPrevented = true;
	      }
	    };
	    return evt;
	  };
	
	  CustomEvent.prototype = window.Event.prototype;
	  window.CustomEvent = CustomEvent; // expose definition to window
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js